import { ComponentDataDestService } from '../component-data-dest.service';
import { environment } from '../../../environment/environment';
import { Observable } from 'rxjs';

interface CreateEducationalPathDTO {
  name: string;
  organization_id: number;
  visibility: string;
  items: any[];
  maintenance_tasks: any[];
  requirements: any[];
  assigned_users: any[];
  descriptions: {
    [key: string]: {
      translation_text: string;
    };
  };
  version: {
    start_date: string;
    end_date: string;
    required_maintenance_minutes: number;
    recurrence_value: number;
    recurrence_unit: string;
    auto_transfer_enabled: boolean;
  };
}

export function addEducationalPath(componentDataDestService: ComponentDataDestService) {
  return {
    name: 'Add Educational Path',
    description: 'Creates a new educational path',
    execute: (data: CreateEducationalPathDTO): Observable<any> => {
      return componentDataDestService.http.post(`${environment.apiUrl}/events/paths`, data);
    },
    settings: {
      fields: [
        { key: 'name', label: 'Navn', type: 'text', required: true },
        { 
          key: 'descriptions', 
          label: 'Beskrivelser', 
          type: 'translations', 
          required: true,
          translationConfig: {
            fields: [
              { key: 'translation_text', label: 'Beskrivelse', type: 'textarea' }
            ]
          }
        },
        { key: 'items', label: 'Elementer', type: 'multi-select', options: [], required: true },
        { key: 'maintenance_tasks', label: 'Vedligeholdelsesopgaver', type: 'multi-select', options: [] },
        { key: 'requirements', label: 'Krav', type: 'multi-select', options: [] },
        { key: 'assigned_users', label: 'Tildelte brugere', type: 'multi-select', options: [] },
        { key: 'visibility', label: 'Synlighed', type: 'select', options: ['public', 'private'], required: true },
        { 
          key: 'version.start_date', 
          label: 'Versionens startdato', 
          type: 'date', 
          required: true 
        },
        { 
          key: 'version.end_date', 
          label: 'Versionens slutdato', 
          type: 'date'
        },
        { 
          key: 'version.required_maintenance_minutes', 
          label: 'Krævede vedligeholdelsesminutter', 
          type: 'number', 
          required: true,
          defaultValue: 0
        },
        { 
          key: 'version.recurrence_value', 
          label: 'Gentagelsesværdi', 
          type: 'number', 
          required: true,
          defaultValue: 1
        },
        { 
          key: 'version.recurrence_unit', 
          label: 'Gentagelsesenhed', 
          type: 'select', 
          options: ['days', 'weeks', 'months', 'years'], 
          required: true,
          defaultValue: 'years'
        },
        { 
          key: 'version.auto_transfer_enabled', 
          label: 'Aktivér automatisk overførsel', 
          type: 'checkbox',
          defaultValue: true
        }
      ]
    }
  };
} 